import _ from "lodash";
import * as yup from "yup";

export default () => yup.object().shape({
  uniqueSlug: yup.string().trim().transform(value => _.kebabCase(value)).max(1000, "text_too_long"),
});
